/**
 * Get tt userName to display. If user.name exists it will be used, if not
 * a formatted version of default TR anonymous-.* format will be used
 * @param {object} user  - TT user whose name must be displayed
 * @returns {string} - tt userName to display
 */
export default function (user = {}) {
    if (user?.name && user?.name !== 'undefined') {
        return user.name;
    }
    if (user?.id) {
        return `Anonymous (${user.id.slice(-6)})`;
    }
    return 'Anonymous';
}
